import { useState } from 'react';

const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

export default function FloatingWhatsApp() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 md:bottom-7 md:right-7 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-[#1a1a1a] border border-gray-700 text-white text-sm font-medium px-4 py-3 rounded-xl whitespace-nowrap shadow-xl max-w-[200px] md:max-w-[220px]">
          <div className="flex items-center gap-2 mb-1">
            <span className="w-2 h-2 rounded-full bg-[#2563eb] animate-pulse flex-shrink-0"></span>
            <span className="text-[#2563eb] font-bold text-xs uppercase tracking-wide">En línea ahora</span>
          </div>
          <p className="text-gray-300 text-xs leading-snug">¿En qué podemos ayudarte?</p>
        </div>
      )}

      {/* Button */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="nofollow noreferrer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-[#2563eb] hover:bg-[#1d4ed8] rounded-full shadow-2xl shadow-blue-900/50 transition-all duration-200 cursor-pointer relative"
        aria-label="Contactar por WhatsApp"
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#2563eb] animate-ping opacity-20"></span>
        <i className="ri-whatsapp-line text-white text-xl md:text-3xl relative z-10"></i>
        {/* Online badge */}
        <span className="absolute -top-0.5 -right-0.5 md:-top-1 md:-right-1 w-3 h-3 md:w-4 md:h-4 bg-[#2563eb] border-2 border-[#0d0d0d] rounded-full z-20"></span>
      </a>
    </div>
  );
}
